<template>
  <q-icon
    name="analytics"
    size="sm"
    class="q-ml-sm"
  >
    <q-tooltip>
      <div
        v-for="message in messages"
        :key="message"
      >
        {{ message }}
      </div>
    </q-tooltip>
  </q-icon>
</template>

<script>
export default {
  name: 'AuditMessagesIcon',
  props: {
    messages: {
      type: Array,
      required: true
    }
  }
}
</script>
